import Component from '@bythepixel/component-loader';

export default class ProductView extends Component {
  static selector = '[data-comp-product-view]';

  constructor(containerEl) {
    super(containerEl);
    this.priceDisplay = this.$container.querySelector('[data-price-display]');
    this.variantSelectList = this.$container.querySelector('[data-variant-select-list]');
    this.cartOptions = this.$container.querySelector('[data-cart-options]');
    this.outOfStock = this.$container.querySelector('[data-out-of-stock]');
    this.addToCartContainer = this.$container.querySelector('[comp-add-to-cart]');

    if (this.variantSelectList) {
      this.addProductVariantChangeListener();
    }
  }

  addProductVariantChangeListener() {
    this.variantSelectList.addEventListener('change', () => {
      const selectedProduct = this.variantSelectList.options[this.variantSelectList.selectedIndex];
      const productData = selectedProduct.dataset;
      this.changePriceDisplay(productData.price);
      this.changeAvailability(productData.availability);
      this.changeAddToCartInformation(productData);
    });
  }

  changePriceDisplay(price) {
    this.priceDisplay.innerHTML = `$${price}`;
  }

  changeAvailability(availability) {
    if (availability) {
      this.cartOptions.classList.remove('hidden');
      this.outOfStock.classList.add('hidden');
    } else {
      this.cartOptions.classList.add('hidden');
      this.outOfStock.classList.remove('hidden');
    }
  }

  changeAddToCartInformation(productData) {
    this.addToCartContainer.setAttribute('data-product-id', productData.variantId);
    this.addToCartContainer.setAttribute('data-variant-title', productData.variantTitle);
    this.addToCartContainer.setAttribute('data-price', productData.price);
  }
}
